import api, { ResponseCallback } from '../../services/api.service'
import routeUtil from '../../utils/route.util'
import { AddonName } from '../addon.api'
import { MetaData } from '../meta.api'
import { MetaAttributableType } from '../metaAttribute.api'

const routes = {
  listMetasByAddon: '/addons/{addon}/metaAttributes/{attributableType}/{attributableId}/metas'
}

export default {
  listMetasByAddon (
    addon: AddonName,
    attributableType: MetaAttributableType,
    attributableId: number,
    callback: ResponseCallback<MetaData[]>
  ) {
    const params = { addon, attributableType, attributableId }
    const url = routeUtil.replaceParams(routes.listMetasByAddon, params)
    api.get(url, {}, callback)
  }
}
